@for(u of c; track u) {
  <div>
    {{ u.firstname }} {{ u.lastname }} @if(u.referent) {<span class="fst-italic">(référent·e)</span>}
  </div>
}
@if(c.length === 0) {
  <div>
    <span class="fst-italic text-light-grey">
      Aucun utilisateur associé
    </span>
  </div>
}
